import request from '@/config/axios'

export interface EcommerceAutomationConfigVO {
  id?: number
  enabled: boolean
  mcpUrl: string
  modelId?: number | null
  title: string
  subtitle: string
  disclaimer: string
  systemPrompt: string
  maxToolRounds: number
}

export interface EcommerceToolVO {
  name: string
  description: string
  inputSchema: string
}

export interface EcommerceChatResultVO {
  content: string
  toolCount: number
  calledTools: string[]
  mcpUrl: string
  error: boolean
}

export const EcommerceAutomationConfigApi = {
  get: async (): Promise<EcommerceAutomationConfigVO | null> =>
    request.get({ url: '/ai/ecommerce-automation/config/get' }),
  save: async (data: EcommerceAutomationConfigVO): Promise<number> =>
    request.put({ url: '/ai/ecommerce-automation/config/save', data })
}

export const EcommerceAutomationChatApi = {
  chat: async (message: string): Promise<EcommerceChatResultVO> =>
    request.post({ url: '/ai/ecommerce-automation/chat', data: { message } }),
  tools: async (): Promise<EcommerceToolVO[]> =>
    request.get({ url: '/ai/ecommerce-automation/tools' }),
  health: async (): Promise<{ enabled: boolean; mcpUrl: string; ready: boolean; toolCount: number }> =>
    request.get({ url: '/ai/ecommerce-automation/health' })
}
